module.exports = __webpack_public_path__ + "images/archive-7f8bbc.svg";